module.exports = "<span class=\"label label-default\" *ngFor=\"let id of identities\">{{id.ean}}</span>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/identity/identities/identities.component.html
// module id = ./src/app/identity/identities/identities.component.html
// module chunks = main